import "./App.scss";
import { Route, Routes, Navigate, Outlet, BrowserRouter } from "react-router-dom";
import RegisterComponent from "./components/register/register";
import httpApiCall from "./service/api.service";
// import { createStore } from 'state-pool';
// import { settingsReducer, partnerReducer } from "./reducers/reducers";
import LoginComponent from "./components/login/login";
import  Layout  from "./components/elements/Layout.lazy";
// import store from "./store";
// import { ToastContainer } from "react-toastify";
import { IntercomProvider } from "react-use-intercom";
import DashboardComponent from "./components/Dashboard/Dashboard.lazy";
import { accessTokenLogin, getStorageValue, setLoginData, setStorageKey } from "./service/shared.service";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import Businesses from "./components/Businesses/Businesses";
import ProfileComponent from "./components/Profile/Profile";

import NewBusinessComponent from "./components/new-business/new-business";
import Calculator from "./components/Calculator/Calculator";
import { saveAgentBusinessCount, savePartnerData, saveSettingData } from "./Redux/Slices/MainSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SubPartner from "./components/sub-partner/sub-partner";
import NewSubPartner from "./components/sub-partner/new-sub-partner/new-sub-partner";
import Support from "./components/Support/Support";
import Commissions from "./components/Commisions/Commissions";
import ScheduleTraining from "./components/training/schedule-training/schedule-training";
import TrainingList from "./components/training/training-list/training/training-list";
import { Global } from "@emotion/react";
import Globel from "./components/GlobelSearch/GlobelSearch";
import GlobelSearch from "./components/GlobelSearch/GlobelSearch";
import Faqs from "./components/faqs/faqs";
import Terms from "./components/Term&Conditions/Terms";
import Verfication from "./components/Verification/Verfication";
import Courses from "./components/courses/Course.lazy";
import CoursesDetails from "./components/courses/details/details";
import CourseQuiz from "./components/courses/quiz/quiz";
import Assests from "./components/Assests/Assests";
import Users from "./components/Users/Users";
import { Toaster } from "react-hot-toast";
import BottomBar from "./components/Bottom/BottomBar";
import MoreDetails from "./components/Details/MoreDetails";
import Report from "./Export/Report";
const INTERCOM_APP_ID = "hnf5ub99";
const isAuthenticated = () => {
  if (getStorageValue("partnerToken")) {
    return true;
  } else {
    return false;
  }
};

const PrivateRoutes = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
};

const Routing = () => {
  return (
    // <BrowserRouter>
    <Routes>
      <Route path="/register" element={<RegisterComponent />} />
      <Route path="/login" element={<LoginComponent />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/verification" element={<Verfication />} />
      <Route path="/report" element={<Report />} />
      <Route path="/app" element={<PrivateRoutes />}>
        <Route path="dashboard" element={ <DashboardComponent/>} />
        <Route path="business" element={<Businesses />} />
        <Route path="profile" element={<ProfileComponent />} />
        <Route path="new-business" element={<NewBusinessComponent />} />
        <Route path="calculator" element={<Calculator />} />
        <Route path="sub-partner" element={<SubPartner />} />
        <Route path="users" element={<Users />} />
        <Route path="payout-reports" element={<Commissions />} />
        <Route path="new-sub-partner" element={<NewSubPartner />} />
        <Route path="support" element={<Support />} />
        <Route path="schedule-training" element={<ScheduleTraining />} >
          <Route path=":event_id"/>
        </Route>
        <Route path="training-list" element={<TrainingList />} />
        <Route path="more-details" element={<MoreDetails />} />
        <Route path="globelsearch" element={<GlobelSearch />} />
          <Route path="assets" element={<Assests />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="courses" element={<Courses />} />
        <Route path="courses/details" element={<CoursesDetails />} >
          <Route
              path=":course_id"
            />
        </Route>
        <Route path="courses/quiz" element={<CourseQuiz />} >
          <Route
              path=":course_id"
            />
        </Route>

      </Route>
      <Route path="*" element={<LoginComponent />} />
    </Routes>
    // </BrowserRouter>
  );
};

const setMapKey = () => {
  let mapKey = '';
  if (window.location.href.includes('.credee.com')) {
    mapKey = 'AIzaSyAC-sYjuX1Avr6W_kNtfL06HQtNnWluAvs';
  } else {
    mapKey = 'AIzaSyDfsOQdPjaofT7MKQFzlazJn1rnZANi91w'
  }
  setStorageKey('map_api_key', mapKey)
}

const App = () => {
  const graphData = useSelector((state: any) => state?.APIData?.graphData);

  const dispatch = useDispatch();
  useEffect(() => {
    const setSettings = async () => {
      if (getStorageValue("partnerToken")) {
        let partnerData = await accessTokenLogin();
        if (partnerData && !partnerData.is_error) {
          setStorageKey('partnerData', partnerData);
          // setLoginData(partnerData, '');
          if (partnerData.partner_profile && partnerData.partner_profile[0]) {
            dispatch(saveAgentBusinessCount({
              total_agents: partnerData.partner_profile[0]['total_agents'],
              total_business: partnerData.partner_profile[0]['total_business']
            }))
          }
        }
        dispatch(savePartnerData(partnerData));
      }
      let data = await httpApiCall({ api: "get_settings", type: "post" });
      setStorageKey('settingsData', data);
      dispatch(saveSettingData(data));
    }
    setSettings();
  }, [])


  // const  setSettings = async () => {
  //   if(getStorageValue("partnerToken")) {
  //     const body = {
  //       access_token:getStorageValue("partnerToken")
  //     }
  //     let partnerData = await httpApiCall({ api: "access_token_login", type: "post", body });
  //     if (partnerData && !partnerData.is_error) {
  //       // setStorageKey('partnerData', partnerData);
  //       dispatch(savePartnerData(partnerData));
  //     }
  //   }
  //   let data = await httpApiCall({ api: "get_settings", type: "post" });
  //   dispatch(saveSettingData(data));

  // }
  setMapKey();
  if (!getStorageValue("user")) {
    var a = new Date();
    var nav = window.navigator;
    var screen = window.screen;
    var guid = nav.mimeTypes.length + "";
    guid += nav.userAgent.replace(/\D+/g, "");
    guid += nav.plugins.length;
    guid += screen.height || "";
    guid += screen.width || "";
    guid += screen.pixelDepth || "";
    guid += a.getTime();
    // var hash = result;
    setStorageKey("user", guid);
  }
  if (!getStorageValue("partnerToken")) {
    <Navigate to="/login" replace={true} />;
  } else {
    <Navigate to="/app/dashboard" replace={true} />;
  }
  return (
    <>
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot={getStorageValue("partnerToken") ? true : false}>
        <BrowserRouter basename="/partner">
          <div className={getStorageValue("partnerToken") ? 'app_routing' : ''} >
            <Layout />

            <div className={`${getStorageValue("partnerToken") && !graphData ? 'main_Class_all' : graphData ?  "main_Class_all graphShow" : 'col-lg-12'}`}>
              <Routing />
            </div>
            <div className={`${!getStorageValue("partnerToken") ? "d-none": ""} d-md-none bottom_bar`}>
              <BottomBar/>
            </div>
          </div>
        </BrowserRouter>
        <Toaster position="bottom-center"/>
        {/* <ToastContainer closeButton={false} position="bottom-center" theme="dark" limit={1}/> */}
      </IntercomProvider>
    </>
  );
}

export default App;
